/* sign to newsletter
 ==================================================================================================== */
(function() {
    $(document).on('submit', '#site-widget-stay-in-touch-form', function(event){
        //alert('working');
        event.preventDefault();
        var container = $(this).parent();
        var height = container.height();

        var form = $('#site-widget-stay-in-touch-form').serialize();
        var formActionUrl = $('#site-widget-stay-in-touch-form').attr('action');

        container.html('<div class="ajax-placeholder" style="height: '+height+'px;"></div>');

        $.post(formActionUrl, form, function(data){
           // console.log(data.result);

            if (typeof data == 'object' && data.result == 'success') {
                container.replaceWith(data.msg);
            } else {
                container.replaceWith(data);
            }
        });
    });
})();